function getOS() {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  
  if (userAgent.indexOf('Win') !== -1 || platform.indexOf('Win') !== -1) {
    return 'windows';
  } else if (userAgent.indexOf('Mac') !== -1 || platform.indexOf('Mac') !== -1) {
    return 'mac';
  } else if (userAgent.indexOf('Linux') !== -1 || platform.indexOf('Linux') !== -1) {
    return 'linux';
  }
  return 'unknown';
}

// Add OS class to body
document.body.classList.add(getOS() + '-os');


function updateCartIcon(itemCount) {
  const cartIcon = document.querySelector('.cart-link');
  if (itemCount > 0) {
    cartIcon.classList.add('has-items');
    cartIcon.classList.remove('cart-empty');
  } else {
    cartIcon.classList.remove('has-items');
    cartIcon.classList.add('cart-empty');
  }
}

document.addEventListener('DOMContentLoaded', function() {

  // Listen for cart updates
  document.addEventListener('cart:updated', function(event) {
    if (event.detail) {
      updateCartIcon(event.detail.cart.item_count);
    }
  });

  // Initial check on page load
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateCartIcon(cart.item_count);
    })
    .catch(error => console.error('Error:', error));


});


document.addEventListener('DOMContentLoaded', function() {
  // Select the search icon span element
  const searchIcon = document.querySelector('span.inline-icon.icon-search-svg');
  
  // Select the search input
  const searchInput = document.getElementById('header-search-input');
  
  // Add click event listener to the search icon
  searchIcon.addEventListener('click', function() {
    // Focus the input element
    searchInput.focus();
  });
});



$(document).ready(function(){
	$('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function(){
		$(this).toggleClass('open');
        $('.mobile-menu').toggleClass('open-mobile-nav');
      
	});
});

$(document).ready(function(){
	$('span.inline-icon.search-icon-svg').click(function(){
        $('#header-global').toggleClass('searchbar-open');
      
	});
});


var headerLoad = document.getElementById('header-global');

TweenMax.fromTo(headerLoad, .2, {opacity: 0, y: 0}, {opacity: 1, y: 0});



document.addEventListener("DOMContentLoaded", function(event) {
  
    // wait until window is loaded (images, external JS, external stylesheets, fonts, links, and other media assets)
    window.addEventListener("load", function(event) {
  
      // makes sure it runs after last render tick
      window.requestAnimationFrame(function() {


// (The homepage hero text used to fade in here, once every image, video and
// script had loaded. It now animates in as soon as it's parsed; see the
// hero in sections/homepage-template.liquid.)

if (window.innerWidth <= 768) {
  gsap.set('#video-content', { clearProps: 'all' });
}

        
        
        // (A white panel, #fixed-element, used to fade in here to hide the
        // hero text, which stayed fixed to the screen. The hero now handles
        // its own text on every screen size, so the panel is retired; see
        // application.css.liquid.)
   
gsap.to('.zoom', {
  scale: 1.2,
  duration: 2,
  scrollTrigger: {
    trigger: '.zoom',
    scrub: true,
    start: 'top bottom'
  }
})

 gsap.to('.zoom-2', {
  scale: 1.2,
  duration: 2,
  scrollTrigger: {
    trigger: '.zoom-2',
    scrub: true,
    start: 'top bottom'
  }
})

$(function() {
    var header = $('.header');
    var menu = $('#menu');
    var isHomepage = $('body').hasClass('template-index');
    var isDvdsPage = $('body').hasClass('template-page.dvds');
    var isFilmsPage = $('body').hasClass('template-page.films');
    var isContactPage = $('body').hasClass('template-page.contact');
    var isSearchPage = $('body').hasClass('template-search');
    var isStreamsPage = $('body').hasClass('template-page.streams-page');
  var isOnlineStore = $('body').hasClass('template-page.online-store');
  var isProduct = document.body.className.indexOf('template-product') !== -1;
  var isInCinemas = $('body').hasClass('template-page.in-cinemas');
  var is404Page = $('body').hasClass('template-404');
  var isCartPage = $('body').hasClass('template-cart');
    var isMetaobjectFilmsPage = $('body').hasClass('template-metaobject/films');
  var isMerch = $('body').hasClass('template-product.merch');
  var isAbout = $('body').hasClass('template-page');
  var isPrivacyPolicy = $('body').hasClass('template-page.privacy-policy');
  var isAccountPage = $('body').hasClass('template-page.account');


  
    
    // Function to check if we're on mobile
    function isMobile() {
        return window.innerWidth <= 767;
    }
    
    // Function to apply correct classes based on page and device
    function updateClasses() {
        // Always dark pages
        if (isDvdsPage || isFilmsPage || isSearchPage || isProduct || isContactPage || isOnlineStore || isInCinemas || isCartPage || isMerch || isAbout || isPrivacyPolicy || isAccountPage || is404Page ) {
            header.addClass('dark');
            menu.addClass('dark');
            return; // Exit early since we know we want dark mode
        }
        
        // Mobile-only dark pages
        if ((isStreamsPage || isMetaobjectFilmsPage) && isMobile()) {
            header.addClass('dark');
            menu.addClass('dark');
            return; // Exit early since we want dark mode on mobile
        }
        
        // For homepage and other pages, use scroll behavior
        // Homepage: turn solid as the first section after the hero reaches
        // the header, measured from where it actually sits (on desktop the
        // pinned hero adds scroll room before it; on phones the hero is one
        // screen tall).
        var afterHero = $('.content-wrap').find('[class^="content-block-"]').not('.content-block-video_background').first();
        var scrollThreshold = isHomepage
          ? (afterHero.length
              ? afterHero.offset().top - header.outerHeight()
              : $(window).height() * (isMobile() ? 1.5 : 0.85))
          : 100;
        var scroll = $(window).scrollTop();
        var heightThreshold_end = $("#footer-global").offset().top;
        
        if (scroll >= scrollThreshold && scroll <= heightThreshold_end) {
            header.addClass('dark');
            menu.addClass('dark');
        } else {
            header.removeClass('dark');
            menu.removeClass('dark');
        }
    }
    
    // Run on page load
    updateClasses();
    
    // Run on scroll
    $(window).scroll(updateClasses);
    
    // Run on window resize
    $(window).resize(updateClasses);
    
    // Debug information
    console.log("Page detection:", {
        "isHomepage": isHomepage,
        "isCartPage": isCartPage,
        "isDvdsPage": isDvdsPage,
        "isFilmsPage": isFilmsPage,
        "isContactPage": isContactPage,
        "isSearchPage": isSearchPage,
        "isStreamsPage": isStreamsPage,
        "is404Page": isStreamsPage,
        "isMetaobjectFilmsPage": isMetaobjectFilmsPage,
        "isMobile": isMobile()
    });
});



if (window.innerWidth > 768) {
  // Explicit start and end: the second slide starts hidden in CSS, so a
  // plain .from() would animate it from hidden to hidden.
  const tl = gsap.fromTo(".card", { opacity: 0, y: -10 }, {
    paused: true,
    opacity: 1,
    y: 0,
    duration: 1,
    stagger: {
      each: 4,
      repeat: 1,
      repeatDelay: 1.75,
      yoyo: true,
      ease: 'power2.inOut',
    }
  })

  // Scroll plays the slides (first in view, swap to the second), then holds
  // on the second for a while before the pin releases and the next section
  // arrives, so there's time to read it. Linear, so scroll distance maps
  // evenly onto the sequence.
  const slides = tl.duration() - 2;
  const animation = gsap.timeline({ paused: true })
    .fromTo(tl, { time: 1 }, { time: tl.duration() - 1, duration: slides, ease: 'none' })
    .to({}, { duration: 3 });

  // The hero text stays fixed to the screen throughout. Pinning wraps the
  // hero block in a positioned layer that would carry fixed children along,
  // so the text layer moves out of the block first (same place in the page,
  // just not inside what gets pinned).
  const heroBlock = document.querySelector(".content-block-video_background");
  const heroText = document.getElementById("video-content");
  if (heroBlock && heroText) heroBlock.parentNode.insertBefore(heroText, heroBlock);

  // The whole hero block is pinned, with pin spacing, so the next section
  // genuinely waits until the slides are done. (Pinning only the text
  // layer, as before, added no scroll space: the next section slid up over
  // the hero while the slides were still going.)
  ScrollTrigger.create({
    trigger: ".content-block-video_background",
    pin: ".content-block-video_background",
    pinSpacing: true,
    start: "top top",
    // About one and a half screens of scrolling: the first slide, the swap,
    // then a hold on the second, roughly the last half.
    end: "+=150%",
    scrub: true,
    markers: false,
    animation: animation,
  })

  // Created after the pin, so its position allows for the pin's spacing.
  // The text stays fixed throughout; the next section slides up over it.
  // Once the hero has scrolled completely away, the text hides, so it can
  // never show through further down the page; scrolling back brings it back.
  if (heroBlock && heroText) {
    ScrollTrigger.create({
      trigger: heroBlock,
      start: "bottom top",
      onEnter: () => gsap.set(heroText, { autoAlpha: 0 }),
      onLeaveBack: () => gsap.set(heroText, { autoAlpha: 1 })
    });
  }

} else {
  gsap.set(".card", { opacity: 1 });
}

// (The homepage's intro, feature banner text, Explore cards and In Cinemas
// text used to be hidden here once the whole page had loaded, then faded
// back in on scroll, replaying each time. They now use the gentle one-off
// scroll reveal in page-transitions.js. The banner image zooms below are
// unchanged.)

// On Demand and film page hero text: fades in as it comes into view.
const hero = gsap.utils.toArray('.hero-slider-content, .film-details .left-column');

hero.forEach((box, i) => {
  const anim = gsap.fromTo(box, {autoAlpha: 0, y: 30}, {duration: .3, autoAlpha: 1, y: 0, delay: 0});
  ScrollTrigger.create({
    trigger: box,
    animation: anim,
    toggleActions: "restart pause resume pause"
  
    
  });
});



});
      
});
});





$(function() {                      
  $(".list-view").click(function() { 
    $('.films-a-z').toggleClass("visible");   
  });
});

$(function() {                      
  $(".films-a-z-categories").click(function() { 
    $('.films-genres').toggleClass("visible");   
  });
});

$(document).ready(function () {
    $('.region-toggle-section').on('click', function (e) {
        $(this).find('.region-title').toggleClass('minus');
       
    });
});


$(document).ready(function () {
    $('.region-title').on('click', function (e) {
        $(this).next('.toggle-dropdown').toggleClass('listings-visible');
    });


if ( window.innerWidth < 700 ) {
    if ($('body').hasClass('template-page\.streams-page')) {
      $('#header-global').addClass('dark');
    }
  }

  if ( window.innerWidth < 700 ) {
    if ($('body').hasClass('template-page\.dvds')) {
      $('#header-global').addClass('dark');
    }
  }



  


  



if ($('body').hasClass('template-page\.dvds')) {
  $('#header-global').addClass('dark');
}

if ($('body').hasClass('template-page\.films')) {
  $('#header-global').addClass('dark');
}

  

if ($('body').hasClass('template-collection\.shop')) {
  $('body').addClass('owl-dvd-slide');
}

if ($('body').hasClass('template-page\.in-cinemas')) {
  $('body').addClass('owl-dvd-slide');
}

  


if ($('body').hasClass('template-page')) {
  $('#header-global').addClass('dark');
}


  

  if ($('body').hasClass('template-collection.collection-settings')) {
    $('#header-global').addClass('dark');
}

  if ($('body').hasClass('template-search')) {
    $('#header-global').addClass('dark');
}



    


 

  

  
  
});


document.addEventListener('DOMContentLoaded', function() {
  const owlCarousel = document.querySelector('.owl-carousel');
  
  if (owlCarousel) {
    // Add a CSS class to disable transitions initially
    owlCarousel.classList.add('no-transition');
    
    // Your original callback function logic
    function onChangedCallback(event) {
      // Only add owl-dvd-slide class if the shop-slide is active
      if ($(".owl-carousel .owl-item.active .shop-slide").length > 0) {
        $("body").addClass("owl-dvd-slide");
      } else {
        $("body").removeClass("owl-dvd-slide");
      }
    }
    
    // Function to check initial slide state
    function checkInitialSlideState() {
      // Wait a moment for carousel to fully initialize
      setTimeout(() => {
        onChangedCallback(); // Call the same logic for initial state
      }, 50);
    }
    
    // Initialize Owl Carousel with your existing settings
    if (typeof jQuery !== 'undefined') {
      $('.owl-carousel').owlCarousel({
        items: 1,
        loop: false,
        URLhashListener: true,
        autoplayHoverPause: false,
        startPosition: 'URLHash',
        autoHeight: true,
        smartSpeed: 0, // Disable initial animation
        onTranslated: onChangedCallback,
        onInitialized: checkInitialSlideState
      });
      
      // Re-enable transitions after a short delay
      setTimeout(() => {
        owlCarousel.classList.remove('no-transition');
        // Restore normal transition speed
        $('.owl-carousel').data('owl.carousel').settings.smartSpeed = 500;
      }, 400);
    }
  }
  
  // Show footer after 2 seconds to prevent flash
  setTimeout(() => {
    document.body.classList.add('footer-show');
  }, 500);
  
  // Your existing updateActiveSection function
  function updateActiveSection() {
    let currentHash = window.location.hash;
    
    if (!currentHash) {
      const firstSlide = document.querySelector('.owl-slide');
      currentHash = firstSlide ? '#' + firstSlide.getAttribute('data-hash') : '#stream';
    }
    
    document.querySelectorAll('.nav-icons li a').forEach(function(link) {
      link.classList.remove('active-nav');
    });
    
    switch(currentHash) {
      case '#in-cinemas':
        document.querySelectorAll('.in-cinemas-icon a').forEach(a => a.classList.add('active-nav'));
        break;
      case '#stream':
        document.querySelectorAll('.streaming-icon a').forEach(a => a.classList.add('active-nav'));
        break;
      case '#shop':
        document.querySelectorAll('.dvd-icon a').forEach(a => a.classList.add('active-nav'));
        break;
    }
  }
  
  updateActiveSection();
  window.addEventListener('hashchange', updateActiveSection);
});

$(document).ready(function() {


  // Add to Cart Form
  let
    addToCartFormSelector = '#add-to-cart-form',
    productOptionSelector = addToCartFormSelector + ' [name*=option]';

  let productForm = {
    onProductOptionChanged: function(event) {
      let
        $form = $(this).closest(addToCartFormSelector),
        selectedVariant = productForm.getActiveVariant($form);

      $form.trigger('form:change', [selectedVariant]);
    },
    getActiveVariant: function($form) {
      let
        variants = JSON.parse(decodeURIComponent($form.attr('data-variants'))),
        formData = $form.serializeArray(),
        formOptions = {
          option1: null,
          option2: null,
          option3: null
        },
        selectedVariant = null;

      $.each(formData, function(index, item) {
        if (item.name.indexOf('option') !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      $.each(variants, function(index, variant) {
        if (variant.option1 === formOptions.option1 && variant.option2 === formOptions.option2 && variant.option3 === formOptions.option3) {
          selectedVariant = variant;
          return false;
        }
      });

      return selectedVariant;

    },
    validate: function(event, selectedVariant) {
      let
        $form = $(this),
        hasVariant = selectedVariant !== null,
        canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0,
        $id = $form.find('.js-variant-id'),
        $addToCartButton = $form.find('#add-to-cart-button'),
        $price = $form.find('.js-price'),
        formattedVariantPrice,
        priceHtml;

      if (hasVariant) {
        formattedVariantPrice = '$' + (selectedVariant.price/100).toFixed(2);
        priceHtml = '<span class="money">'+formattedVariantPrice+'</span>';
        window.history.replaceState(null, null, '?variant='+selectedVariant.id);
      }
      else {
        priceHtml = $price.attr('data-default-price');
      }

      if (canAddToCart) {
        $id.val(selectedVariant.id);
        $addToCartButton.prop('disabled', false);
      }
      else {
        $id.val('');
        $addToCartButton.prop('disabled', true);
      }

      $price.html(priceHtml);

    },
    init: function() {
      $(document).on('change', productOptionSelector, productForm.onProductOptionChanged);
      $(document).on('form:change', addToCartFormSelector, productForm.validate);
    }
  };

  productForm.init();

  // Ajax API Functionality
  let miniCartContentsSelector = '.js-mini-cart-contents';
  let ajaxify = {
    onAddToCart: function(event) {
      event.preventDefault();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: ajaxify.onCartUpdated,
        error: ajaxify.onError
      });
    },
    onCartUpdated: function() {
      let
        $miniCartFieldset = $(miniCartContentsSelector + ' .js-cart-fieldset');

      $miniCartFieldset.prop('disabled', true);

      $.ajax({
        type: 'GET',
        url: '/cart',
        context: document.body,
        success: function(context) {
          let
            $dataCartContents = $(context).find('.js-cart-page-contents'),
            dataCartHtml = $dataCartContents.html(),
            dataCartItemCount = $dataCartContents.attr('data-cart-item-count'),
            $miniCartContents = $(miniCartContentsSelector),
            $cartItemCount = $('.js-cart-item-count');

          $cartItemCount.text(dataCartItemCount);
$miniCartContents.html(dataCartHtml);

// Update cart icon classes
const cartIcon = document.querySelector('.cart-link');
if (parseInt(dataCartItemCount) > 0) {
  cartIcon.classList.add('has-items');
  cartIcon.classList.remove('cart-empty');
} else {
  cartIcon.classList.remove('has-items');
  cartIcon.classList.add('cart-empty');
}

if (parseInt(dataCartItemCount) > 0) {
            ajaxify.openCart();
          }
          else {
            ajaxify.closeCart();
          }
        }
      });
    },
    onError: function(XMLHttpRequest, textStatus) {
      let data = XMLHttpRequest.responseJSON;
      alert(data.status + ' - ' + data.message + ': ' + data.description);
    },
    onCartButtonClick: function(event) {
      let
        isCartOpen = $('html').hasClass('mini-cart-open'),
        isInCart = window.location.href.indexOf('/cart') !== -1;

      if (!isInCart) {
        event.preventDefault();
        if (!isCartOpen) {
          ajaxify.openCart();
        }
        else {
          ajaxify.closeCart();
        }
      }
    },
    openCart: function() {
      $('html').addClass('mini-cart-open');
    },
    closeCart: function() {
      $('html').removeClass('mini-cart-open');
    },
    init: function() {
      $(document).on('submit', addToCartFormSelector, ajaxify.onAddToCart);

      $(document).on('click', '.js-cart-link, .js-keep-shopping', ajaxify.onCartButtonClick);
    }
  };

  ajaxify.init();


  // Quantity Fields
  let
    quantityFieldSelector = '.js-quantity-field',
    quantityButtonSelector = '.js-quantity-button',
    quantityPickerSelector = '.js-quantity-picker',
    quantityPicker = {
      onButtonClick: function(event) {
        // alert('button clicked');
        let
          $button = $(this),
          $picker = $button.closest(quantityPickerSelector),
          $quantity = $picker.find('.js-quantity-field'),
          quantityValue = parseInt($quantity.val()),
          max = $quantity.attr('max') ? parseInt($quantity.attr('max')) : null;

        if ($button.hasClass('plus') && (max === null || quantityValue+1 <= max)) {
          // do something for plus click
          $quantity.val(quantityValue + 1).change();
        }
        else if ($button.hasClass('minus')) {
          // do something for minus click
          $quantity.val(quantityValue - 1).change();
        }
      },
      onChange: function(event) {
        let
          $field = $(this),
          $picker = $field.closest(quantityPickerSelector),
          $quantityText = $picker.find('.js-quantity-text'),
          shouldDisableMinus = parseInt(this.value) === parseInt($field.attr('min')),
          shouldDisablePlus = parseInt(this.value) === parseInt($field.attr('max')),
          $minusButton = $picker.find('.js-quantity-button.minus'),
          $plusButton = $picker.find('.js-quantity-button.plus');

        $quantityText.text(this.value);

        if (shouldDisableMinus) {
          $minusButton.prop('disabled', true);
        }
        else if ($minusButton.prop('disabled') === true) {
          $minusButton.prop('disabled', false);
        }

        if (shouldDisablePlus) {
          $plusButton.prop('disabled', true);
        }
        else if ($plusButton.prop('disabled') === true) {
          $plusButton.prop('disabled', false);
        }
      },
      init: function() {
        $(document).on('click', quantityButtonSelector, quantityPicker.onButtonClick);
        $(document).on('change', quantityFieldSelector, quantityPicker.onChange);
      }
    };

  quantityPicker.init()



  // Line Item
  let
    removeLineSelector = '.js-remove-line',
    lineQuantitySelector = '.js-line-quantity';

  let lineItem = {
    isInMiniCart: function(element) {
      let
        $element = $(element),
        $miniCart = $element.closest(miniCartContentsSelector),
        isInMiniCart = $miniCart.length !== 0;

      return isInMiniCart;
    },
    onLineQuantityChanged: function(event) {
      let
        quantity = this.value,
        id = $(this).attr('id').replace('updates_', ''),
        changes = {
          quantity: quantity,
          id: id
        },
        isInMiniCart = lineItem.isInMiniCart(this);

      if (isInMiniCart) {
        $.post('/cart/change.js', changes, ajaxify.onCartUpdated, 'json');
      }
    },
    onLineRemoved: function(event) {
      let isInMiniCart = lineItem.isInMiniCart(this);

      if (isInMiniCart) {
        event.preventDefault();
        
        let
          $removeLink = $(this),
          removeQuery = $removeLink.attr('href').split('change?')[1];
        $.post('/cart/change.js', removeQuery, ajaxify.onCartUpdated, 'json');
      }
    },
    init: function() {
      $(document).on('click', removeLineSelector, lineItem.onLineRemoved);
      $(document).on('change', lineQuantitySelector, lineItem.onLineQuantityChanged);
    }
  };

  lineItem.init();

  // Search Input
  let
    searchInputSelector = '.js-search-input',
    searchSubmitSelector = '.js-search-submit',
    onSearchInputKeyup = function(event) {
      let
        $form = $(this).closest('form'),
        $button = $form.find(searchSubmitSelector),
        shouldDisableButton = this.value.length === 0;

      $button.prop('disabled', shouldDisableButton);

    };

    $(document).on('keyup', searchInputSelector, onSearchInputKeyup);

  // Slideshows
  let
    slidesSelector = '.js-slides',
    prevButtonSelector = '.js-slider-button-prev',
    nextButtonSelector = '.js-slider-button-next';

  // Product
  let
    productSlideshowSelector = '.js-product-slideshow',
    currentSlideSelector = '.js-current-slide',
    productSlideshows = {
      onBeforeChange: function(event, slick, currentSlide, nextSlide) {
        let $currentSlide = slick.$slider.closest(productSlideshowSelector).find(currentSlideSelector);

        $currentSlide.text(nextSlide+1);
      },
      setup: function($element) {
        let
          $slides = $element.find(slidesSelector),
          $prevButton = $element.find(prevButtonSelector),
          $nextButton = $element.find(nextButtonSelector),
          productSlideshowOptions = {
            slidesToShow: 1,
            nextArrow: $nextButton,
            prevArrow: $prevButton,
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1
          };

        if ($slides.children().length > 1) {
          $slides.on('beforeChange', productSlideshows.onBeforeChange).slick(productSlideshowOptions);
        }
      },
      init: function () {
        $(productSlideshowSelector).each(function() {
          productSlideshows.setup($(this));
        });
      }
    };


  productSlideshows.init();




  

  // Section Slideshow
  let
    sectionSlideshowSelector = '.js-section-slideshow',
    sectionSlideshows = {
      setup: function($element) {
        let
          $slides = $element.find(slidesSelector),
          shouldAutoplay = $element.attr('data-autoplay') === 'true',
          autoplaySpeed = parseInt($element.attr('data-autoplay-speed')),
          $prevButton = $element.find(prevButtonSelector),
          $nextButton = $element.find(nextButtonSelector),
          sectionSlideshowOptions = {
            fade: true,
            nextArrow: $nextButton,
            prevArrow: $prevButton,
            autoplay: shouldAutoplay,
            autoplaySpeed: autoplaySpeed
            
          };

        if ($slides.children().length > 1) {
          $slides.slick(sectionSlideshowOptions);
        }
      },
      init: function() {
        $(sectionSlideshowSelector).each(function() {
          sectionSlideshows.setup($(this));
        });
      }
    };

  sectionSlideshows.init();


});

$(function(){
  $(".trailer-btn").click(function(){
    $(".popup").fadeIn("fast");
  })
  
  $(".trailer-close").click(function(){
    // Get the iframe element
    const iframe = $(".popup iframe");
    
    // Store the current src
    const currentSrc = iframe.attr('src');
    
    // Remove the src to stop the video
    iframe.attr('src', '');
    
    // Hide the popup
    $(".popup").fadeOut("fast");
    
    // Restore the src after popup is hidden (so it's ready for next time)
    setTimeout(function() {
      iframe.attr('src', currentSrc);
    }, 300); // Match the fadeOut duration
  })
  
  $(".contents").click(function(e){
    e.stopPropagation();
  })
  
  // Optional: Also stop video if user clicks outside the modal content
  $(".popup").click(function(e){
    if (e.target === this) {
      $(".trailer-close").click(); // Trigger the close functionality
    }
  })
})




$(document).ajaxComplete(function() {
  $.getJSON('/cart.js', function(cart) {
    var $cartLink = $('.cart-link');
    if (cart.item_count === 0) {
      $cartLink.addClass('cart-empty').removeClass('has-items');
    } else {
      $cartLink.removeClass('cart-empty').addClass('has-items');
    }
  });
});

setTimeout(function() {
  document.getElementById('footer-global').classList.add('visible');
}, 3000);